import React from 'react';
import { ChevronRightIcon, DownloadIcon, FileTextIcon, LeafIcon, PackageIcon, RecycleIcon, Share2Icon, SparklesIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { categories, collectionsByDate, formatLongDate, toKey, type CategoryId } from '../../data/calendrierCollectes';
const icons: Record<CategoryId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  dechets: Trash2Icon,
  organiques: LeafIcon,
  jardin: SproutIcon,
  lourds: PackageIcon,
  speciales: SparklesIcon
};
interface DayDetailsProps {
  date: Date;
}
export function DayDetails({
  date
}: DayDetailsProps) {
  const events = collectionsByDate[toKey(date)] ?? [];
  return <section aria-live="polite" aria-labelledby="day-title" data-id="element-696" data-mp="16q86snac0ww">
      <h2 id="day-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-697" data-mp="651mbfkm4xkx">
        {formatLongDate(date)}
      </h2>

      {events.length === 0 ? <p className="mt-4 rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-6 text-sm text-slate-500" data-id="element-698" data-mp="2qwafhdnewkcr">
          No collection scheduled at your address that day.
        </p> : <ul className="mt-4 space-y-3" data-id="element-699" data-mp="2osgf0p7ew1bb">
          {events.map(id => {
        const category = categories[id];
        const Icon = icons[id];
        return <li key={id} data-id="element-700" data-mp="2xscwa5rh1xwc">
                <button type="button" className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-701" data-mp="2xslaq238tb9n">
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${category.chip}`} aria-hidden="true" data-id="element-702" data-mp="32pv8c50sct8k">
                    <Icon className="h-5 w-5" data-id="element-703" data-mp="3gjm8wnwjh2s5" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-704" data-mp="3cgpvdbluvwv2">
                    <span className="block font-bold uppercase tracking-wide text-ville-navy" data-id="element-705" data-mp="3qfft8tgi20kh">{category.label}</span>
                    <span className="block text-sm text-slate-500" data-id="element-706" data-mp="3lhnt5c5pb857">{category.time}</span>
                  </span>
                  <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-707" data-mp="2j4rhtzz9s67j" />
                </button>
              </li>;
      })}
        </ul>}

      <div className="mt-6 grid grid-cols-3 divide-x divide-slate-100 overflow-hidden rounded-3xl border border-slate-200 bg-white" data-id="element-708" data-mp="2s4ejmmvwve14">
        {[{
        label: 'PDF',
        Icon: FileTextIcon
      }, {
        label: 'Download',
        Icon: DownloadIcon
      }, {
        label: 'Share',
        Icon: Share2Icon
      }].map(({
        label,
        Icon
      }) => <button key={label} type="button" className="flex flex-col items-center gap-1.5 px-2 py-4 text-xs font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-sand hover:text-ville-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-709" data-mp="36v5btw1f0f4r">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-710" data-mp="1gifzh7tfzx8n">
              <Icon className="h-5 w-5" data-id="element-711" data-mp="1dw6tfhqein70" />
            </span>
            {label}
          </button>)}
      </div>
    </section>;
}